import { TestProps } from "../../../types";
import { AtTagProps } from "../../atoms";
import { AtTagFolioStatus } from "../../atoms/at-tag/at-tag.types";

export enum HeaderDetailsType {
  USER = "user",
  FOLIO = "folio",
}

export type FolioDetailsProps = {
  variant: HeaderDetailsType.FOLIO;
  folioInfo: {
    isGuest: boolean;
    folioNumber: string;
    customer: string;
    createdAt: string;
    status: AtTagFolioStatus;
    modifiedAt: string;
    organization: string;
    asignedTo?: string;
  };
  onRetakeFolio: () => void;
  onCloseFolio: () => void;
};

export type UserDetailsProps = {
  variant: HeaderDetailsType.USER;
  userInfo: {
    fullName: string;
    createdAt: string;
    updatedAt: string;
    tags: {
      state: AtTagProps;
      campaign: AtTagProps;
      organization: AtTagProps;
    };
  };
};

type BaseProps = TestProps & {
  loading?: boolean;
  onBack: () => void;
};

export type HeaderDetailsProps = BaseProps &
  (UserDetailsProps | FolioDetailsProps);
